export class PureCloudModel{
    category : string ;
    type : string;
    interaction : interaction;
}
export class interaction
{
     id :  string ;
     connectedTime : Date;
     phone : string;
     isConnected : boolean;
     isDisconnected  : boolean;
     state  : string;
     isDialeralse : boolean;
     displayAddress : string;
     queueName : string;
     calledNumber  : string;
     direction : string;
     startTime : Date;
     attributes : attributes;
}

export class attributes
{
    casenumber : number ;
}